import { Box } from "@mui/system";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React, { useEffect } from "react";
import { MasterDataActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { IProductCategory } from "model/MasterData/IProductCategory";
import { Checkbox, Stack, Switch } from "@mui/material";
import { TableHelper } from "helpers";
import { I18nTranslator, translations } from "utils/i18n";

const ProductCategory = () => {
  const dispatch = useAppDispatch();
  const productCategory = useAppSelector(
    (state) => state.MasterDataReducer.productCategory
  );
  const columns: GridColDef[] = [
    TableHelper.renderSTT(),
    {
      field: "description",
      headerName: I18nTranslator(translations.masterData.productType),
      width: 300,
    },
    {
      field: "apply",
      headerName: I18nTranslator(translations.masterData.apply),
      align: "center",
      headerAlign: "center",
      width: 100,
      renderCell: ({ row }) => {
        return <Switch />;
      },
    },
  ];

  useEffect(() => {
    _getProductCategories();
  }, []);

  const _getProductCategories = () => {
    dispatch(MasterDataActions.getProductCategories.request());
  };
  return (
    <div style={{ width: "100%", marginTop: "10px" }}>
      <DataGrid
        rows={
          productCategory.data?.map((item, index) => {
            return {
              ...item,
              no: index,
            };
          }) as { [key: string]: any }[]
        }
        columns={columns}
        pageSize={100}
        autoHeight
        disableSelectionOnClick
        hideFooter
        hideFooterSelectedRowCount
        hideFooterPagination
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              Không có dữ liệu
            </Stack>
          ),
        }}
      />
    </div>
  );
};
export default ProductCategory;
